import React from 'react';
import SuperAdminLayout from '../../components/admin/SuperAdminLayout';
import SystemAlerts from '../../components/admin/SystemAlerts';

const SystemAlertsPage: React.FC = () => {
  return (
    <SuperAdminLayout>
      <SystemAlerts />
    </SuperAdminLayout>
  );
};

export default SystemAlertsPage;